/* eslint-disable prettier/prettier */
import { Dispatch } from 'redux';
import { REMERCHANDISE_START, REMERCHANDISE_SUCCESS, REMERCHANDISE_FAILED, RESET_REMERCHANDISE } from './types';
import { ReduxStore } from '../payload-types';
import { ApiClient } from '../api.client';
import { LINKS, API_DATE_FORMAT } from '@trip-ux/constants';
import { getLabels } from '../request.mappers';
import { toUpper, get } from 'lodash';
import { dayjs } from '@trip-ux/common';

export const createLead =
  (callback = () => null, payload) =>
  async (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<unknown> => {
    const state = getState();
    const labels = getLabels(state.config, state.tms, 'translationConfig');
    const dateFormat = get(labels, 'configuration.apiDateFormat');
    dispatch({ type: REMERCHANDISE_START });
    const leadPayload = {
      firstName: payload.travellerName,
      email: payload.email,
      tripStartDate: dayjs(state.quoteForm.form.departureDate, dateFormat).format(API_DATE_FORMAT),
      language: toUpper(state.config.locale)
    };

    return apiClient(dispatch, getState)
      .post(LINKS.REMERCHANDISE, leadPayload, { headers: { lang: toUpper(state.config.locale) } })
      .then(data => {
        dispatch({ type: REMERCHANDISE_SUCCESS, payload:data });
        callback();
      })
      .catch(e => {
        dispatch({ type: REMERCHANDISE_FAILED, payload: e });
      });
  };


  export const clearRemerchandise = () => (dispatch: Dispatch) => {
    dispatch({
      type: RESET_REMERCHANDISE
    });
  };
